import { acceptRegulationsByUser, saveProfileData, updateProfilePassword, getUser, createAccount, forgotPassword, resetPassword } from '../utils/api'
//import { showLoading, hideLoading } from 'react-redux-loading'

export const SET_AUTHED_USER = 'SET_AUTHED_USER'
export const ACCEPT_REGULATIONS = 'ACCEPT_REGULATIONS'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'

export function setAuthedUser (authedUser) {
	return {
		type: SET_AUTHED_USER,
		authedUser
	}
}

export function handleSignIn (username, password) {
	return (dispatch) => {
		return getUser(username, password)
		.then((res) => {
			return res
		})
	}
}

export function handleSignUp (data) {
	return (dispatch) => {
		return createAccount(data)
		.then((res) => {
			return res
		})
	}
}

export function handleForgotPassword (username) {
	return (dispatch) => {
		return forgotPassword(username)
		.then((res) => {
			return res
		})
	}
}

export function handleResetPassword (hashId, password) {
	return (dispatch) => {
		return resetPassword(hashId, password)
		.then((res) => {
			return res
		})
	}
}

export function handleUpdateProfile (data) {
	return (dispatch, getState) => {
		const { authedUser } = getState()
		const userId = authedUser.id

		//dispatch(showLoading())

		return saveProfileData(userId, data)
		.then((user) => {
			dispatch(updateProfile(user))
		})
		//.then(() => dispatch(hideLoading()))
	}
}

export function updateProfile (user) {
	return {
		type: UPDATE_PROFILE,
		user
	}
}

export function handleUpdatePassword (data) {
	return (dispatch, getState) => {
		const { authedUser } = getState()
		const userId = authedUser.id

		return updateProfilePassword(userId, data)
		.then((res) => {
			return res
		})
	}
}

export function handleAcceptRegulations (userId) {
	return (dispatch) => {

		return acceptRegulationsByUser(userId)
			.then(() => {
				dispatch(acceptRegulations(userId))
			})
	}
}

function acceptRegulations (userId) {
	return {
		type: ACCEPT_REGULATIONS,
		userId
	}
}


// WEBPACK FOOTER //
// ./src/actions/authedUser.js